"use client"

import { useState, useEffect, useRef } from "react"
import { useLanguage } from "../../../../../contexts/LanguageContext"
import PropTypes from "prop-types"

const Counter = ({ onFinish }) => {
  const [step, setStep] = useState(-1)
  const timerRef = useRef(null)
  const { t } = useLanguage()

  useEffect(() => {
    setStep(-1)
    doNext()

    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  const doNext = () => {
    if (step + 1 > 2) {
      onFinish()
    } else {
      setStep(step + 1)
    }
  }
  timerRef.current = setTimeout(doNext, 1000)

  if (step <= 0) {
    return <div className="counter c0">&nbsp;</div>
  } else if (step === 1) {
    return <div className="counter c1">&nbsp;</div>
  } else {
    return <div className="counter c2">{t("go")}</div>
  }
}

Counter.propTypes = {
  onFinish: PropTypes.func.isRequired,
}

export default Counter
